import { c as _c } from "react/compiler-runtime";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { AspectRatio } from "../ui/aspect-ratio";
import Image from "next/image";
import { ExternalLink, Timer, User } from "lucide-react";
import { Avatar } from "../ui/avatar";
import { parseBlogDescription } from "@/hooks/parse-blog-description";
type BlogCardProps = {
  title: string;
  slug: string;
  coverSrc: string;
  description: string;
  author?: string;
  date: string;
  category: string;
};
export const BlogCard = t0 => {
  const $ = _c(37);
  const {
    title,
    slug,
    coverSrc,
    description,
    author,
    date,
    category
  } = t0;
  let t1;
  if ($[0] !== description) {
    t1 = parseBlogDescription(description);
    $[0] = description;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const parsedDescription = t1;
  let t2;
  if ($[2] !== coverSrc || $[3] !== title) {
    t2 = <AspectRatio ratio={1.7777777777777777} className="w-full overflow-hidden rounded-2xl"><Image src={coverSrc} alt={title} fill={true} className="size-full object-cover transition-transform duration-300 group-hover:scale-[1.03]" sizes="395px" loading="lazy" /></AspectRatio>;
    $[2] = coverSrc;
    $[3] = title;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== category) {
    t3 = <Badge variant="outline" className="text-[11px] font-semibold tracking-wide uppercase" dangerouslySetInnerHTML={{
      __html: category
    }} />;
    $[5] = category;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-muted-foreground flex shrink-0 items-center gap-1 text-xs leading-none"><Timer size={11} className="shrink-0" />{"7 Min Read"}</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t3) {
    t5 = <div className="mt-3 flex items-center justify-between gap-2">{t3}{t4}</div>;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="absolute inset-0" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== title) {
    t7 = <CardTitle className="text-base leading-snug font-semibold">{t6}{title}</CardTitle>;
    $[11] = title;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== slug || $[14] !== t7) {
    t8 = <a href={slug} target="_blank">{t7}</a>;
    $[13] = slug;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t2 || $[17] !== t5 || $[18] !== t8) {
    t9 = <CardHeader className="gap-2 pb-3">{t2}{t5}{t8}</CardHeader>;
    $[16] = t2;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== parsedDescription) {
    t10 = <CardContent className="mt-auto pt-0 pb-0"><CardDescription className="line-clamp-3 text-sm leading-relaxed">{parsedDescription}</CardDescription></CardContent>;
    $[20] = parsedDescription;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Avatar size="default" className="grid shrink-0 place-content-center"><User size={16} /></Avatar>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== author) {
    t12 = <span className="text-foreground truncate text-xs font-semibold">{author}</span>;
    $[23] = author;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== date) {
    t13 = <span className="text-muted-foreground text-xs"><time dateTime={date}>{date}</time></span>;
    $[25] = date;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <div className="flex flex-1 flex-col gap-0.5 overflow-hidden">{t12}{t13}</div>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ExternalLink size={14} className="text-muted-foreground shrink-0 opacity-0 transition-opacity duration-200 group-hover:opacity-100" aria-hidden="true" />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t14) {
    t16 = <CardFooter className="bg-card border-t-0"><div className="flex w-full items-center gap-3">{t11}{t14}{t15}</div></CardFooter>;
    $[31] = t14;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t10 || $[34] !== t16 || $[35] !== t9) {
    t17 = <Card className="group border-border relative flex h-full flex-col gap-0 overflow-hidden transition-shadow duration-200 hover:shadow-2xl">{t9}{t10}{t16}</Card>;
    $[33] = t10;
    $[34] = t16;
    $[35] = t9;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
};